import { Checkbox, Input } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import React from 'react';

import { CloseOutlined, SearchOutlined } from '@ant-design/icons';

import styles from './index.less';

export interface ISearchFilterPanel {
  leftComp?: React.ReactNode;
  onSearch?: (value: string) => void;
  searchText?: string;
  showFilter?: boolean;
  enableFilter?: boolean;
  onFilterVisibilityChange?: (value: boolean) => void;
  style?: React.CSSProperties;
}

export const SearchFilterPanel: React.FC<ISearchFilterPanel> = ({
  leftComp = '',
  onFilterVisibilityChange,
  onSearch,
  showFilter,
  enableFilter = true,
  searchText = '',
  style,
}) => {
  const handleCloseSearch = () => {
    onSearch?.('');
  };

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value: inputValue } = e.target;
    onSearch?.(inputValue);
  };

  const handleCheckboxChange = (e: CheckboxChangeEvent) => {
    onFilterVisibilityChange && onFilterVisibilityChange(e.target.checked);
  };

  return (
    <div className={styles.searchFilterPanel} style={style}>
      {leftComp}
      <div className={styles.operationGroup}>
        <Input
          prefix={<SearchOutlined />}
          suffix={<CloseOutlined onClick={handleCloseSearch} />}
          onChange={handleSearch}
          placeholder="type something"
          size="small"
          autoFocus
          value={searchText}
        />
        {enableFilter ? (
          <div className={styles.operationButton}>
            <Checkbox onChange={handleCheckboxChange} checked={showFilter}>
              Show Filters
            </Checkbox>
          </div>
        ) : null}
      </div>
    </div>
  );
};
